import { CloseRounded } from '@mui/icons-material'
import { Box, Drawer } from '@mui/material'

interface FsLeftInfoDrawerProps {
  open: boolean
  onClose: () => void
  children: React.ReactNode
}

const FsLeftInfoDrawer = (props: FsLeftInfoDrawerProps) => {
  const { open, onClose, children } = props
  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={onClose}
      ModalProps={{
        keepMounted: false,
      }}
      slotProps={{
        paper: {
          sx: {
            height: 'calc(100% - 74px)',
            top: 74,
            width: 550,
            padding: 4,
            elevation: 0,
            paddingTop: 6,
            borderTopRightRadius: 4,
          },
        },
      }}
      variant="temporary"
      elevation={4}
    >
      <Box
        onClick={onClose}
        display="flex"
        justifyContent="flex-end"
        sx={{
          cursor: 'pointer',
          width: 'fit-content',
          alignSelf: 'flex-end',
          zIndex: 50,
          mt: -4.25,
          mr: -2.5,
          mb: 1,
        }}
      >
        <CloseRounded />
      </Box>
      {children}
    </Drawer>
  )
}

export default FsLeftInfoDrawer
